module.exports = __webpack_public_path__ + "static/media/terms-banner-graphic.14364244.png";